import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import Select from '../Select'
import {
  validateRSPO,
  required,
  composeValidators,
} from '../../utils/validation'

import TextInput from '../../components/TextInput/index'
import Button from '../../components/Button'
import { voivodeships, unitTypes } from './utils'
import colors from '../../styles/colors'
import saveIcon from '../../images/saveIcon.svg'
import searchIcon from '../../images/searchIcon.svg'

const UnitForm = (props) => {
  const checkError = (id) => {
    const error = document.getElementById(`error_${id}`)
    if (error) {
      error.setAttribute('tabindex', '0')
      error.setAttribute('role', 'alert')
    }
  }

  return (
    <Form
      initialValues={
        props.importedUnit.rspo !== -1
          ? {
              ...props.importedUnit,
            }
          : { ...props.initialValues }
      }
      mutators={{
        ...arrayMutators,
      }}
      onSubmit={(values) => props.onSubmit(values)}
    >
      {({ handleSubmit, submitting, invalid, values }) => (
        <>
          <StyledField
            component={TextInput}
            label="Identyfikator RSPO"
            type="text"
            name="rspo"
            maxLength="10"
            validate={composeValidators(required, validateRSPO)}
            onChange={checkError('rspo')}
            onBlur={checkError('rspo')}
          />
          <StyledField
            fieldWidth="100%"
            component={Select}
            label="Typ"
            aria-label={'Typ'}
            placeholder=""
            type="text"
            name="publicUnit"
            options={unitTypes}
            disabled
          />

          <StyledField
            component={TextInput}
            label="Nazwa"
            type="text"
            name="name"
            maxLength="100"
            disabled
          />
          <StyledField
            component={Select}
            fieldWidth="100%"
            label="Województwo"
            aria-label={'Województwo'}
            placeholder=""
            type="text"
            name="voivodeship"
            options={voivodeships}
            disabled
          />
          <StyledField
            component={TextInput}
            type="text"
            label="Kod pocztowy"
            name="postcode"
            maxLength="6"
            disabled
          />
          <StyledField
            component={TextInput}
            type="text"
            label="Miasto"
            name="city"
            maxLength="50"
            disabled
          />
          <StyledField
            component={TextInput}
            type="text"
            label="Adres"
            name="address"
            maxLength="50"
            disabled
          />
          <ButtonWrapper>
            <Button
              label="Wyszukaj"
              marginLeft
              color="default"
              icon={searchIcon}
              disabled={
                submitting ||
                invalid ||
                props.initialValues?.rspo === parseInt(values?.rspo)
              }
              onClick={handleSubmit}
              width="auto"
              altTag=""
              imgAriaHidden={true}
              srText=""
            />
            <Button
              label="Zapisz"
              marginLeft
              color="default"
              icon={saveIcon}
              disabled={submitting || props.importedUnit.rspo === -1}
              onClick={() => props.handleSave()}
              width="auto"
              altTag=""
              imgAriaHidden={true}
              srText=""
            />
          </ButtonWrapper>
        </>
      )}
    </Form>
  )
}

const StyledField = styled(Field)`
  min-width: 97.5%;
  font-size: 14px;
  font-weight: 100;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  > div {
    border: none;
    > div:nth-child(2) {
      display: none;
    }
  }
  &:disabled {
    background: #ebebe4;
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0px 0px 0px 1px ${colors.monza};
  }
`
const ButtonWrapper = styled.div`
  text-align: end;
  margin: 1em;
`

export default UnitForm
